import React, { useEffect, useState, useContext } from "react";
import { MobileNavBase } from "../header";
import { openMenu, resetMenus, setFixedBody } from "./NavBarUnlock";
import UserContext from '../mykbb/UserContext';
import ContentSuppressorContext from '../mykbb/ContentSuppressorContext';
import navigationFallback from "./navigationFallback";
import MyKbb from "../mykbb";
import useEventBus from "../../../eventBus/useEventBus.js";
import useIsBot from "../../../common/hooks/useIsBot";
import debugMode from '../../../utils/debugMode';
import { Alert, Link } from '@argo/ui-elements';
import { css } from '@emotion/react';
import { GLOBALNAV_KBB_BASE_URL } from '../mykbb/utils/constants';
export const AlertStyles = css`
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  z-index: 20;
  top: 90px;

  p {
    display: inline;
    margin: 0px;
  }

  .textComponent {
    display: inline;
  }
`;
function MyKBBHeaderContent({
  withMyKbb,
  navMenuLegal,
  withMyWallet,
  navLinks = navigationFallback.headerLinks,
  suppressZipCode = false,
  slimLittleGuy = false,
  pageId,
  useAuthRedirect = false
}) {
  const initialMenuState = {
    isMenuOpen: false,
    menuId: ''
  };
  const {
    isLoggedIn,
    signOut,
    errorFetchingData
  } = useContext(UserContext);
  const isBot = useIsBot();
  const [menuOpenState, setMenuOpenState] = useState(initialMenuState);
  const [showDismissableAlert, setShowDismissableAlert] = useState(true);
  useEffect(() => {
    const {
      isMenuOpen,
      menuId
    } = menuOpenState;
    const targetMenu = document.getElementById(menuId);
    resetMenus(withMyKbb);
    if (isMenuOpen) {
      openMenu(targetMenu);
    }
    setFixedBody(isMenuOpen);
  }, [menuOpenState.isMenuOpen, menuOpenState.menuId, withMyKbb]);
  useEffect(() => {
    if (errorFetchingData === true) {
      setShowDismissableAlert(true);
    }
  }, [errorFetchingData]);
  useEffect(() => {
    const header = document.getElementsByTagName("header")[0];
    if (menuOpenState.isMenuOpen) {
      header?.classList.add('sticky-position-mobile-mode');
    } else {
      header?.classList.remove('fixed-position-mobile-mode', 'sticky-position-mobile-mode');
    }
  }, [menuOpenState.isMenuOpen, menuOpenState.menuId]);
  const onMenuClick = e => {
    e.preventDefault();
    const {
      isMenuOpen,
      menuId
    } = menuOpenState;
    const targetId = e.currentTarget.id || e.currentTarget.getAttribute('for');
    const openTargetMenu = targetId !== menuId || targetId === menuId && !isMenuOpen;
    setMenuOpenState({
      isMenuOpen: openTargetMenu,
      menuId: targetId
    });
  };
  debugMode() && useEventBus('*', (type, event) => console.log('EventBus:::', type, '-', event));
  useEventBus('userProfile.error', e => console.error("UserProfile Error -", e));
  useEventBus('userProfile.littleGuyClick', e => {
    setMenuOpenState({
      isMenuOpen: e.isMyKbbOpen,
      menuId: 'mykbbToggle'
    });
  });
  return React.createElement(React.Fragment, null, errorFetchingData == true && showDismissableAlert && !isBot ? React.createElement(Alert, {
    css: AlertStyles,
    text: "Sorry, looks like you've been automatically logged out of your account due to a technical issue. No worries, simply log back in to regain access.",
    heading: "Let's get you signed back in!",
    type: "error",
    onAlertClose: () => setShowDismissableAlert(false),
    actionType: "dismissible",
    textComponent: React.createElement(Link, {
      href: `${GLOBALNAV_KBB_BASE_URL}/account/sign-in`,
      dangerouslySetInnerHTML: {
        __html: 'Sign me back in.'
      }
    })
  }) : null, withMyKbb && MyKbb && React.createElement(ContentSuppressorContext.Provider, {
    value: {
      suppressSavedCars: true,
      suppressZipCode
    }
  }, React.createElement(MyKbb, {
    isLoggedIn: errorFetchingData == true ? false : isLoggedIn,
    handleSignOut: signOut,
    onMenuClick: onMenuClick,
    menuOpenState: menuOpenState,
    withMyWallet: withMyWallet,
    setMenuOpenState: setMenuOpenState,
    slimLittleGuy: slimLittleGuy,
    useAuthRedirect: useAuthRedirect
  })), React.createElement(MobileNavBase, {
    links: navLinks,
    navMenuLegal: navMenuLegal,
    onMenuClick: onMenuClick,
    menuOpenState: menuOpenState,
    pageId: pageId
  }));
}
export default MyKBBHeaderContent;